const footer = {
  "footer.cookie": "Cookie Settings",
  "footer.about": "เกี่ยวกับ ACUVUE® DEFINE®",
  "footer.contact": "ติดต่อเรา",
  "footer.policy": "นโยบายความเป็นส่วนตัว",
  "footer.notice": "ประกาศทางกฎหมาย",
  "footer.legal": "<p>เว็บไซต์นี้เผยแพร่โดย บริษัท จอห์นสัน แอนด์ จอห์นสัน เมดเทค (ประเทศไทย) จํากัด</p> <p>ซึ่งเป็นผู้รับผิดชอบเนื้อหาบนเว็บไซต์นี้แต่เพียงผู้เดียว</p>  <p>เว็บไซต์นี้สำหรับใช้งานในประเทศไทย</p>",
}

export default footer
